import moment from 'moment';
import { constraintDateEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const constraintDateCol = (gantt) => ({
  name: 'constraint_date',
  label: 'Fecha de Restricción',
  align: 'center',
  width: '*',
  template: (activity) => {
    const constraintTypes = gantt.config.constraint_types;
    let isOdd = false;

    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.constraint_date;
    }

    if (
      activity.constraint_date &&
      activity.constraint_type != constraintTypes.ASAP &&
      activity.constraint_type != constraintTypes.ALAP
    ) {
      const hasChild = gantt.hasChild(activity.id);
      const momentDate = moment(activity.constraint_date);
      const disabled = activity.progress === 100;

      return `
                <div class="${isOdd ? 'odd-col' : 'non-odd-col'}"
                    style="
                        ${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
                        ${disabled ? 'cursor: not-allowed' : ''}; 
                        color: #121212;
                    ">
                    ${momentDate.format(gantt.currentDateFormat?.replace('hh', 'HH'))}
                </div>
                `;
    }
    return (
      '<div class="' + (isOdd ? 'odd-col' : 'non-odd-col') + '"> </div>'
    );
  },
  resize: true,
  editor: constraintDateEditor,
  hide: !isColumnVisibleByDefault('constraint_date'),
  data_type: 'date',
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → N', 'N → 1'],
  filterable: true
});

export default constraintDateCol; 